import script from "./navBar.vue?vue&type=script&setup=true&lang=js"
export * from "./navBar.vue?vue&type=script&setup=true&lang=js"

import "./navBar.vue?vue&type=style&index=0&id=649afb3e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-649afb3e"]])

export default __exports__